const vi = {
  appTitle: 'Vòng Quay May Mắn',
  loading: 'Đang tải...',

  // PlayerForm
  claimPrizeTitle: 'Nhận giải thưởng!',
  formSubtitle: 'Nhập thông tin để nhận giải thưởng của bạn',
  emailLabel: 'Email (không bắt buộc)',
  emailPlaceholder: 'ban@example.com',
  emailError: 'Vui lòng nhập địa chỉ email hợp lệ.',
  phoneLabel: 'Số điện thoại',
  phonePlaceholder: '+84 234 567 890',
  phoneError: 'Vui lòng nhập số điện thoại hợp lệ.',
  submitInfo: 'Nhận giải!',

  // SpinningWheel
  spin: 'QUAY!',
  spinning: 'Đang quay...',
  congratulations: 'Chúc mừng!!!',
  youWon: 'Bạn đã nhận được:',
  resultFollowupMessage: 'Cô Tâm sẽ liên hệ và tư vấn cho bạn ngay nhé. Cảm ơn!!',
  contactName: 'Ms.Tam_English Class',
  contactPhone: '0373.731.398',
};

export default vi;
